import { http } from "../http-common";

const ManageUnannouncedVisitorSubGrowerService = {
  getCropYears: async () => {
    try {
      const response = await http.get("/cropYears");
      return response;
    } catch (error) {
      throw error;
    }
  },

  getCropStage: async (params) => {
    try {
      const response = await http.get(
        `/crop-stage-calendar/crop-stage-calendar-drop-down?cropYear=${params.cropYear}&isSubGrowerMonitoring=true`
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  getVisitorList: async (params, pageNumber, pageSize) => {
    try {
      const response = await http.post(
        `/sub-grower-muv/get-sub-growers?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        params
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  getHierarchyDropdown: async (data) => {
    try {
      const params = new URLSearchParams();
      params.append("isMuv", data.isMuv);
      if (data.cropYear) {
        params.append("cropYear", data.cropYear);
      }

      const response = await http.get(
        `/hierarchy/hierarchy-drop-down?${params.toString()}`
      );
      return response;
    } catch (error) {
      throw error;
    }
  },

  updateVisitorAssignment: async (visitorData) => {
    try {
      const response = await http.post("/sub-grower-muv", visitorData);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default ManageUnannouncedVisitorSubGrowerService;
